package com.essntl.features.proposal.ui.allproposal

import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalFilterOptions
import com.essntl.features.proposal.domain.model.ProposalModel

sealed interface AllProposalEvent {

    data object GetAllProposal : AllProposalEvent

    data class GetProposalHistoryList(
        val proposalId: String,
    ) : AllProposalEvent

    data class SelectProposal(
        val proposalId: String,
    ) : AllProposalEvent

    data class MakeProposalCopy(
        val proposal: ProposalModel,
    ) : AllProposalEvent

    data class UpdateProposalStatus(
        val proposal: ProposalModel,
        val status: ProposalModel.Status,
    ) : AllProposalEvent

    data class UpdateProposalOwner(
        val proposal: ProposalModel,
        val owner: ProfileModel,
    ) : AllProposalEvent

    data class UpdateProposal(val proposal: ProposalModel) : AllProposalEvent

    data class FilterProposal(val filterOptions: ProposalFilterOptions) : AllProposalEvent

    data object LoadMoreProposals : AllProposalEvent

    data object ClearProposalState : AllProposalEvent
}